const comments = [
  {
    name: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20warm%20friendly%20smile%2C%20soft%20studio%20lighting%2C%20clean%20simple%20background%2C%20professional%20headshot%2C%20modern%20casual%20style%2C%20natural%20expression&width=120&height=120&seq=avatar-bajie-01&orientation=squarish',
    text: '用了八戒影视快半年了，真心觉得好用！资源更新速度超快，热门剧集第二天就有了，画质也很清晰。最满意的是播放真的不卡，之前用其他平台经常缓冲到崩溃，这里基本秒开。',
    date: '2天前',
  },
  {
    name: '电影爱好者老李',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20with%20gentle%20smile%2C%20warm%20studio%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%2C%20casual%20style%2C%20natural%20confident%20expression&width=120&height=120&seq=avatar-bajie-02&orientation=squarish',
    text: '作为一个电影发烧友，八戒影视的片库真的很全。很多冷门的老电影和艺术片都能找到，这点太惊喜了。界面也干净，没有乱七八糟的广告弹窗，观影体验很纯粹。',
    date: '5天前',
  },
  {
    name: '动漫迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20bright%20smile%2C%20soft%20warm%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%2C%20modern%20casual%20look%2C%20fresh%20natural%20expression&width=120&height=120&seq=avatar-bajie-03&orientation=squarish',
    text: '新番更新太及时了！每周追的几部番这里都有，而且翻译质量很高。推荐给所有二次元同好，比某些收费网站的资源还全，关键是完全免费。',
    date: '1周前',
  },
  {
    name: '综艺控阿芳',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20woman%20portrait%20with%20warm%20elegant%20smile%2C%20soft%20studio%20lighting%2C%20simple%20clean%20background%2C%20professional%20headshot%2C%20stylish%20casual%20look%2C%20friendly%20natural%20expression&width=120&height=120&seq=avatar-bajie-04&orientation=squarish',
    text: '周末宅家就靠八戒影视了！各种热门综艺一应俱全，旅行类、音乐类、脱口秀都有。清晰度够用，加载也快，推荐给了身边好多朋友，大家都说好用。',
    date: '2周前',
  },
];

export default function Comments() {
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
  };

  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          用户评价
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">听听真实用户怎么说</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {comments.map((c, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={c.avatar}
                  alt={c.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  width="40"
                  height="40"
                  onError={handleImgError}
                />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.date}</p>
                </div>
                <div className="flex gap-0.5 text-accent-500">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}